var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],class:_vm.$style.loader},[(_vm.loading)?_c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"color":_vm.color,"indeterminate":_vm.loading}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }